window.timberSlider = window.timberSlider || {};
function isHidden(el) {return (el.offsetParent === null)}
timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider')
  }
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'slide',
        animationSpeed: 500,
        animationLoop: true,
        pauseOnHover: true,
        controlNav: false,
        directionNav: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 5000,
        smoothHeight: true
      };

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = false;
    }
    if(!isHidden($slider[0])){
      $slider.flexslider(sliderArgs);
    }
  }
};

// Initialize slider on docready
$(window).on('load', function() {
  timberSlider.init();
});
$(window).on('resize', function(){
  console.log('ox:resize');
  timberSlider.sliders();
})
